import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';

const AlertMessage = ({ content, type, showIcon, icon=faClock, className='gi_warning' }) => {

    return (
        <div className={`grid-row gi_alert__wrap ${className}`}>
            <div className={`usa-alert usa-alert--${type} gi-alert gi-alert__${type}`}>
                <div className={`usa-alert__body gi-alert__body gi-alert__${type}__body`}>
                    {showIcon && <div className='align-self-start'><FontAwesomeIcon icon={icon} /> </div>}
                    <div className={`usa-alert__text gi-alert__${type}__text`}>
                        {content}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlertMessage;